// frontend/src/lib/feedbackClient.ts
import { apiJson } from "./api";

export type FeedbackPayload = {
  ingress_request_id: string;
  rating: "up" | "down" | "1" | "2" | "3" | "4" | "5";
  tags?: string[];
  comment?: string;
  corrected_output?: string;
  expected_output?: string;
  report_sensitive_output?: boolean;
};

import { getTenantUuid, ROOT_TENANT_UUID } from "@/app/ingress/tenant";

/**
 * Resolve tenant UUID for public ingress pages:
 * 1) URL ?tenant_id=<uuid> (end-user shareable link)
 * 2) fallback to app-selected tenant (getTenantUuid)
 * 3) fallback to ROOT_TENANT_UUID (last resort)
 */
function resolveTenantUuidForIngress(): string {
  try {
    const sp = new URLSearchParams(window.location.search || "");
    const tid = String(sp.get("tenant_id") || "").trim();
    if (tid) return tid;
  } catch {
    // ignore
  }

  const fromApp = String(getTenantUuid() || "").trim();
  return fromApp || ROOT_TENANT_UUID;
}

/**
 * Submit feedback to /v1/ingress/feedback.
 * If ingressKey is provided, it will be sent as X-Ingress-Key for api_key apps.
 */
export async function submitIngressFeedback(payload: FeedbackPayload, ingressKey?: string) {
  const headers: Record<string, string> = {};
  if (ingressKey && ingressKey.trim()) {
    headers["X-Ingress-Key"] = ingressKey.trim();
  }

  const tenantUuid = resolveTenantUuidForIngress();

  return apiJson<{ ok: boolean; feedback_event_id: string }>(
    `/v1/ingress/feedback?tenant_id=${encodeURIComponent(tenantUuid)}`,
    {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    }
  );
}


//const ROOT_TENANT_UUID = "00000000-0000-0000-0000-000000000001";

/**
 * Submit feedback to /v1/ingress/feedback.
 * If ingressKey is provided, it will be sent as X-Ingress-Key for api_key apps.
 */
/**export async function submitIngressFeedback(payload: FeedbackPayload, ingressKey?: string) {
  const headers: Record<string, string> = {};
  if (ingressKey && ingressKey.trim()) {
    headers["X-Ingress-Key"] = ingressKey.trim();
  }

  return apiJson<{ ok: boolean; feedback_event_id: string }>(`/v1/ingress/feedback?tenant_id=${ROOT_TENANT_UUID}`, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  });
}*/